import React, { useState } from 'react';
import {
  Dialog,
  Button,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';

const ObjectModal: React.FC<{
  object: string | null;
  setObject(value: string | null): void;
}> = ({ object, setObject }) => {
  const [newObject, setNewObject] = useState<string | null>(null);
  const parsedObject = JSON.parse(String(object));
  return parsedObject ? (
    <Dialog open={!!object}>
      <DialogTitle id="form-dialog-title">@Object</DialogTitle>
      <DialogContent>
        {Object.entries(parsedObject).map(([key, value]) => (
          <div key={key}>
            <Typography variant="caption" color="textSecondary">
              {String(key)}
            </Typography>
            {typeof value === 'object' ? (
              <div>
                <Button
                  disabled={false}
                  variant="outlined"
                  onClick={(e: any) => {
                    if (e.currentTarget) setNewObject(e.currentTarget.value);
                  }}
                  value={JSON.stringify(value)}
                >
                  <i className="bx bx-show" style={{ marginRight: '4px' }}></i>
                  @Object
                </Button>
              </div>
            ) : (
              <Typography>{String(value)}</Typography>
            )}
          </div>
        ))}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => {
            setObject(null);
          }}
          color="primary"
        >
          Ok
        </Button>
      </DialogActions>
      <ObjectModal
        object={newObject}
        setObject={(value: string | null) => setNewObject(value)}
      />
    </Dialog>
  ) : null;
};

export default ObjectModal;
